import AnttRequest from '../entities/AnttRequest'
import { IUserRepository } from '../repositories/IUserRepository'
import IValidateAnttResponse from '../entities/IValidateAnttResponse'

export interface IValidateAntt {
  execute(params: AnttRequest): Promise<IValidateAnttResponse>
}

export default class ValidateAnttImpl implements IValidateAntt {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(params: AnttRequest): Promise<IValidateAnttResponse> {
    const response = await this.userRepository.validateAntt(params)
    return response
  }
}
